<!--
  ToastContainer Component
  Renders all active toasts. Place once in App.svelte.
-->
<script lang="ts">
  import { toastStore } from '../../stores/toastStore';
  import Toast from './Toast.svelte';

  // Checkboxes, radios and buttons take no text, so `z` stays available there (table rows).
  const NON_TEXT_INPUTS = ['checkbox', 'radio', 'button', 'submit', 'reset', 'range', 'file'];

  function isTyping(el: EventTarget | null): boolean {
    if (!(el instanceof HTMLElement)) return false;
    if (el instanceof HTMLInputElement) return !NON_TEXT_INPUTS.includes(el.type);
    return !!el.closest('textarea, select, [contenteditable]');
  }

  function onKeydown(e: KeyboardEvent): void {
    if (e.key.toLowerCase() !== 'z') return;
    // A held key would undo the next-older toast on every repeat.
    if (e.repeat || e.isComposing) return;
    if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey) return;
    if (isTyping(e.target) || document.querySelector('[role="dialog"]')) return;
    const toast = [...$toastStore].reverse().find((t) => t.action);
    if (!toast?.action) return;
    e.preventDefault();
    toastStore.remove(toast.id);
    toast.action.onClick();
  }
</script>

<svelte:window on:keydown={onKeydown} />

<div class="fixed bottom-4 right-4 z-[100] flex flex-col gap-2 w-80">
  {#each $toastStore as toast (toast.id)}
    <Toast {toast} />
  {/each}
</div>
